import React from "react";
import { Layout, Typography, Image } from "antd";
import CommonSidebar from "../../components/CommonSidebar";
import impactImage from "../../assets/focus.jpg"; 

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const OurImpactPage = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout style={{ background: "#fff" }}>
        {/* Sidebar */}
        <CommonSidebar defaultSelectedKey="5" />

        {/* Main Content */}
        <Layout
          style={{
            background: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "start",
            padding: "20px 20px",
            flex: 1, 
          }}
        >
          <Content
            style={{
              width: "100%",
              maxWidth: "100%", 
            }}
          >
            {/* Image Section */}
            <div style={{ textAlign: "left", marginBottom: "30px" }}>
              <Image
                src={impactImage}
                alt="Our Impact"
                style={{
                  width: "100%",
                  borderRadius: "10px",
                }}
                preview={false}
              />
            </div>

            {/* Text Section */}
            <Typography>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                At <strong>Yalla Nellab</strong>, we believe in the power of
                sport to connect people, build confidence and inspire change.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>Creating Opportunities Through Sport</strong> <br />
                We organize and host community events, support local sports
                programs, raise awareness about active, healthy living and
                conduct workshops and seminars that promote teamwork,
                discipline and personal growth. Our goal is to make sport
                accessible to everyone, regardless of background or ability.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>Building Communities That Play Together</strong> <br />
                From small neighborhood pitches to large-scale leagues, our
                reach continues to expand — bringing together players, students,
                workers, professionals and individuals with disabilities under
                one vision:{" "}
                <em>play without barriers</em>. Each event we host creates
                friendships, laughter and memories that last long after the
                final whistle, strengthening community spirit and reminding
                everyone that sport is more than competition — it’s a way to
                belong.
              </Paragraph>

              <Paragraph style={{ fontSize: "16px", color: "#444" }}>
                <strong>Measuring Impact</strong> <br />
                Every project we deliver is guided by data and community
                feedback. We assess participation rates, skill development and
                long-term engagement to ensure our initiatives lead to lasting
                social, physical and emotional impact.
              </Paragraph>
            </Typography>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default OurImpactPage;